import { ViewState } from "redux/constants/App";
import { setBusy, setError, setReady } from "./utils";
import * as Types from "../constants/CompanyConstants";

const initState = {
  loading: false,
  message: "",
  showMessage: false,
  error: false,
  companies: [],
  httpError: {
    status: null,
    message: null,
    errors: [],
  },
  getStatus: ViewState.IDLE,
  company: null,
};


const company = (state = initState, action) => {
  switch (action.type) {
    case Types.STORE_COMPANY:
      return {
        ...state,
        loading: true,
      };
    case Types.STORE_COMPANY_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: action.showMessage,
        loading: false,
        error: action.error,
      };
    case Types.FETCH_COMPANIES:
      return setBusy({ state, statusKey: "getStatus" });
    case Types.FETCH_COMPANIES_FAILED:
      return setError({ state, statusKey: "getStatus", httpError: action.error });
    case Types.FETCH_COMPANIES_OK:
      return setReady({ state, statusKey: "getStatus", payload: { companies: action.payload } });
    case Types.RESET_COMPANY:
      return Object.assign({}, initState)
    case Types.FETCH_COMPANY:
      return {
        ...state,
        loading: true,
      };
    case Types.FETCH_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        company: action.payload.company,
        showMessage: true,
        message: action.payload.message,
        error: false,
      };
    case Types.FETCH_COMPANY_ERROR:
      return {
        ...state,
        loading: false,
        company: null,
        showMessage: true,
        message: action.payload.message,
        error: true,
      };
    case Types.UPDATE_COMPANY:
      return {
        ...state,
        loading: true,
      };
    case Types.UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        company: action.payload.company,
        showMessage: true,
        message: action.payload.message,
        error: false,
      };
    case Types.UPDATE_COMPANY_ERROR:
      return {
        ...state,
        loading: false,
        company: null,
        showMessage: true,
        message: action.payload.message,
        error: true,
      };
    default:
      return state;
  }
};

export default company;
